module.exports = __webpack_public_path__ + "img/c11-min.e5776db3.png";